import * as React from 'react'

import cn from 'classnames'
import { useRecoilValue } from 'recoil'

import { Ids } from '../../../constants/Ids'
import { cld } from '../../../services/CloudinaryService'
import { locale } from '../../../state/locale/atoms/locale'
import { translate } from '../../../state/locale/selectors/translate'
import { GallerySlider } from '../../reusable/GallerySlider'
import { GoogleMaps } from '../../reusable/GoogleMaps'
import { Link } from '../../reusable/Link'
import { ParagraphText } from '../../reusable/ParagraphText'
import styles from './Rent.module.scss'
import { IRentProps } from './Rent.types'

export const Rent = ({ data }: IRentProps) => {
  const lang = useRecoilValue(locale)
  const i18n = useRecoilValue(translate).rent
  const images = data.gallery.map((image) => cld.image(image.provider_metadata.public_id).toURL())

  return (
    <div className={styles.rentWrapper}>
      <h2 className={styles.pageTitle} id={Ids.rentLocations}>
        {i18n.pageTitle}
      </h2>
      <div className={styles.locationsWrapper}>
        <div className={cn(styles.column, styles.mapContainer)}>
          <GoogleMaps map={data.map} locale={lang} />
        </div>
        <div className={styles.column}>
          <h2 className={styles.pageTitle} id={'locations'}>
            {data.locationsTitle}
          </h2>
          <ParagraphText text={data.locationsDescription} />
        </div>
      </div>
      <GallerySlider images={images} />
      <h2 className={cn(styles.paragraph, styles.linkDescription)} id={Ids.rentOffers}>
        {i18n.linkDescription}
      </h2>
      <Link className={styles.buttonLink} to={data.offersLink} blank={true}>
        {i18n.linkButton}
      </Link>
    </div>
  )
}
